<template lang="pug">
    header.landingpage(v-if="currentView === 'LandingPage'")
        button.hamburger.hamburger--3dy(type="button" :class="{ 'is-active': sidebar }" @click="toggleSidebar")
            span.hamburger-box
                span.hamburger-inner
        .container
            .columns.is-hidden-touch
                .main-menu-wrapper.column.mr-3
                    nav#main-menu.is-pulled-right
                        tree-menu(:items="items" :max-depth="2" :delay="400")
            .columns.logo-col
                .logo-wrapper.column
                    img#logo.is-pulled-right(src="@/assets/aba-nrw_logo.png")
    header.contentpage(v-else-if="currentView === 'ContentPage'")
        button.hamburger.hamburger--3dy(type="button" :class="{ 'is-active': sidebar }" @click="toggleSidebar")
            span.hamburger-box
                span.hamburger-inner
        .container
            .columns.is-hidden-touch
                .main-menu-wrapper.column.mr-3
                    nav#main-menu.is-pulled-right
                        tree-menu(:items="items" :max-depth="2" :delay="400")
            .columns.logo-col
                .logo-wrapper.column
                    img#logo.is-pulled-right(src="@/assets/aba-nrw_logo.png")
            .columns
                div.pageName
                    h2.is-size-3.is-uppercase.has-text-weight-medium {{ pageTitle }}
    header(v-else)
        button.hamburger.hamburger--3dy(type="button" :class="{ 'is-active': sidebar }" @click="toggleSidebar")
            span.hamburger-box
                span.hamburger-inner
        .container
            .columns.is-hidden-touch
                .main-menu-wrapper.column.mr-3
                    nav#main-menu.is-pulled-right
                        tree-menu(:items="items" :max-depth="2" :delay="400")
            .columns.logo-col
                .logo-wrapper.column
                    img#logo.is-pulled-right(src="@/assets/aba-nrw_logo.png")
            .columns
                div.pageName
                    h2.is-size-3.is-uppercase.has-text-weight-medium {{ pageTitle }}

</template>

<script>

// import _ from 'lodash'
import get from 'lodash.get'
import trim from 'lodash.trim'
import cloneDeep from 'lodash.clonedeep'

import { mapGetters, mapMutations } from 'vuex'

import NestedSet from '@/nested-set-lib'

export default {
    name: 'Header',
    props: {
        section: {
            type: Object,
            required: true
        }
    },
    computed: {
        items() {
            const menu = this.menus.find(menu => menu.key === 'main-menu')
            let items = get(menu, 'menuItems') || []
            items = cloneDeep(items)

            if (items.length) {
                return NestedSet.createTree(items)
            }

            return items
        },
        pageTitle() {
            return _.get(this.$route, 'name');
            //return 'test';
        },

        image() {
            const storageRoute = trim(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`, '/')

            const fit = 'fit=fill&w=350&h=150'

            let width = this.logo.width
            let height = this.logo.height

            return {
                src: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}`,
                error: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=greyscale`,
                loading: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=blur`,
                width,
                height,
            }
        },
        ...mapGetters({
            logo: 'logo',
            menus: 'menus',
            currentView: 'currentPage/view',
            sidebar: 'sidebar',
        })
    },
    methods: {
        openSearch() {
            console.log('open search bar');
        },
        toggleSidebar() {
            this.updateSidebarVisibility(! this.sidebar)
        },
        ...mapMutations({
            updateSidebarVisibility: 'updateSidebarVisibility',
        })
    },
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import '~@/assets/sass/variables';

    header
        background-image: url('~@/assets/aba_header_full.png')
        background-position: center -195px
        background-repeat: no-repeat
        min-height: 410px
        z-index: 100

        +until-widescreen
            background-position: center -275px
            min-height: 330px

        +mobile
            min-height: 240px


        .logo-wrapper.column
            padding: 0
            margin-top: 2rem
            margin-right: 20rem
            padding-right: 10px
            #logo
                height: 90px
                
            +until-widescreen
                margin-right: 30px
                margin-top: -55px
                padding: 0
                #logo
                    height: 50px


    header.landingpage
        background-image: url('~@/assets/aba_header_hp.png')
        background-position: center -195px
        min-height: 250px
        +until-widescreen
            background-position: center -280px
            min-height: 180px
        @media (max-width: 670px)
            background-position: center -30px
            background-size: 670px auto

        .logo-wrapper.column
            +until-widescreen
                margin-right: 30px
                margin-top: -43px
                padding: 0
                #logo
                    height: 50px            

    header
        .pageName h2
            margin-top: 4rem
            margin-left: 1.4rem
            +until-widescreen
                margin-top: 8rem
                position: absolute
            +touch
                margin-top: 8.6rem
                font-size: 1.6rem !important
            +mobile
                margin-top: 8.6rem
                font-size: 1.2rem !important

        .logo-col
            +until-widescreen
                display: block



        .hamburger
            height: 55px
            outline: none
            +desktop
                display: none

        .main-menu-wrapper
            padding-bottom: 0
            margin-right: 20rem
            padding-right: 0px

            #main-menu
                z-index: 10

                & /deep/
                    ul
                        &.tree-menu
                            & > li
                                transition: background-color .3s ease
                                &:not(.full-width)
                                    position: relative
                                & > .tree-item a
                                    text-decoration: none
                                    font-weight: 600
                                    font-size: 14px
                                    text-transform: uppercase
                                    color: #222222
                                    padding: 15px
                                    display: inline-block
                                    transition: color .3s ease
                                &.hover
                                    & > .tree-item a
                                        color: $abagreen
                                &.has-children
                                    & > .tree-item a:after
                                        font-family: 'Font Awesome 5 Free' !important
                                        speak: none
                                        content: '\f107'
                                        padding-left: 6px
                                        transition: color .3s ease

                                li
                                    // padding: 0 9px
                                    width: 100%
                                    background-color: $abagreen
                                    display: inline-flex
                                    & > .tree-item a
                                        font-weight: normal
                                        color: #fff
                                        display: block
                                        max-width: 300px
                                        overflow: hidden
                                        text-overflow: ellipsis
                                        white-space: nowrap
                                        &:before
                                            font-family: 'Font Awesome 5 Free' !important
                                            speak: none
                                            font-weight: 900
                                            content: "\F054"
                                            padding-right: 6px
                                            transition: color .3s ease
                                        .svg-inline--fa
                                            display: none
                                    &.hover
                                        background-color: #fff
                                        & > .tree-item a
                                            color: #222222
                                            &:before
                                                color: #222222
                    & > ul
                        &.tree-menu
                            & > li
                                // padding: 0 9px 33px 9px
                                display: inline-block
                                & > .tree-item a
                                    padding: 16px 12px 12px 12px
                                    border-bottom: 5px solid transparent
                                &.hover > .tree-item a.router-link-exact-active
                                    color: $abagreen
                                & > ul
                                    &.tree-menu
                                        position: absolute
                                        left: 0
                                        top: 100%
                                        display: flex
                                        flex-direction: column
                                        min-width: 100%
                                        box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.3)
                                        &.full-width
                                            background: #e30018
                                            width: 100%
                                            columns: 3
                                            column-gap: 0
                                            display: block
                                            +widescreen
                                                columns: 4
                                            li > .tree-item
                                                width: 100%
                                                a
                                                    max-width: initial
                            ul ul
                                min-width: 200px
                                margin-bottom: 9px
                                position: absolute
                                right: 100%
                                top: 0
                                // box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.3)
                                li > .tree-item a
                                    // padding: 10px 15px
                                    // font-size: .8rem
                                    // &:before
                                    //     font-size: 0.5rem
                                    //     position: relative
                                    //     top: -1px

                    .show-enter-active, .show-leave-active
                        transition: opacity 0.3s ease, transform 0.3s ease
                        transform-origin: left center
                    .show-enter, .show-leave-to
                        opacity: 0
                        transform: translateY(6px)


</style>
